var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="dialogPaintStrapList_empty"> <div id="dialogPaintStrapListItem"></div> </div>';
}
return __p;
};
